import { HttpClient, HttpHeaders} from '@angular/common/http';
import {Headers} from '@angular/http'


export const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
  }; 

export const httpOptionsImage = {
    headers: new HttpHeaders({
        'Accept': 'application/json'
      })
  }; 

  export const timeZone = {
    ET : 'Eastern Standard Time',
    CT :'Central Standard Time',
    MT : 'Mountain Standard Time',
    PT : 'Pacific Standard Time',
    AKT: 'Alaska Standard Time',
    HT : 'Hawaii–Aleutian Standard Time'
  }

export const roleID = {
    SUPER_ADMIN_ROLE_ID: 1,
    BRAND_ADMIN_ROLE_ID: 2,
    SALES_REP_ROLE_ID: 3,
    SPEAKER_ROLE_ID: 4,
    MARKETING_ROLE_ID:5
}

export const noVenueID = {
    noVenueAvailable: 22
}

export const virtualVenue = {
    virtualVenueID: 21
}

